var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_transfer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-224, -159)",
    stroke: "#0E1C39",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6",
    transform: "translate(223, 158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,33.0488989 C26.7589926,33.0488989 33.0488989,26.7589926 33.0488989,19 C33.0488989,11.2410074 26.7589926,4.95110109 19,4.95110109 C11.2410074,4.95110109 4.95110109,11.2410074 4.95110109,19",
    id: "\\u692D\\u5706\\u5F62",
    transform: "translate(19, 19) rotate(-118) translate(-19, -19)"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84-6",
    points: "33.2304218 18.2334735 19.5433192 18.2334735 23.1335845 15.3744777"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84-6",
    transform: "translate(24.5741, 25.0313) scale(-1, -1) translate(-24.5741, -25.0313)",
    points: "31.4176607 26.3908987 17.730558 26.3908987 21.3208234 23.671757"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransfer);
export default __webpack_public_path__ + "static/media/icon_transfer.d73805c79dc41c759e8c26c7d5cc0979.svg";
export { ForwardRef as ReactComponent };